module.exports = __webpack_public_path__ + "tile-1-overlay-1LKQicC.webp";